import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { MenuItemLink, getResources, AUTH_GET_PERMISSIONS } from 'react-admin'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import DashboardIcon from '@material-ui/icons/Timeline'
import InstalationsIcon from '@material-ui/icons/Dashboard'
import CertificationIcon from '@material-ui/icons/CheckCircle'
import ValidationIcon from '@material-ui/icons/CheckBox'
import SchemasIcon from '@material-ui/icons/Description'
import TechDataIcon from '@material-ui/icons/Assignment'
import UserIcon from '@material-ui/icons/Person'
import OptionsIcon from '@material-ui/icons/Build'
import BienesIcon from '@material-ui/icons/Home'
import EDAIcon from '@material-ui/icons/Public'
// import PermisosIcon from '@material-ui/icons/SupervisorAccount'
import DBIcon from '@material-ui/icons/Storage'
import NotificationIcon from '@material-ui/icons/Event'

import SubMenu from './SubMenu'

import authProvider from '../../utils/authProvider'

const styles = {
    menu : {
        position: 'fixed',
        overflowY: 'scroll',
        height: '100%',
        zIndex : 0,
    },
    root: {
        fontSize : '0.9rem',
        lineHeight : '1.2em',
        paddingTop : 20,
        paddingBottom : 16,
        paddingLeft : 25,
    },
    active: {
        color: '#33C2D5' ,
    },
    icon: {
        paddingRight: '0.5em',
        '& svg': { fontSize : 18 }
    },
}


// const toTitleCase = (string) => {
//     return string.toLowerCase().split(' ')
//         .map(word => {
//             return word.replace(word[0], word[0].toUpperCase());
//         })
//         .join(' ');
// }

class Menu extends Component {

    constructor(props) {
        super(props)
        this.state = {
            permissions: {},
            menuActivos : false,
        }
    }

    static propTypes = {
        onMenuClick: PropTypes.func,
        logout: PropTypes.object,
    }

    handleToggle = menu => {
        this.setState(state => ({ [menu]: !state[menu] }));
    }

    componentDidMount() {
        authProvider(AUTH_GET_PERMISSIONS, {})
            .then(response => {
                this.setState({ permissions: response })
            })
            .catch((e) => {
                console.error(e);
            });
    }

    renderItem(item, role) {
        const { classes } = this.props
        if (!item.roles || (!!role && !!item.roles && item.roles.includes(role))) {
            if (item.path){
                return (
                    <MenuItemLink
                        classes={classes}
                        key={item.name}
                        to={`${item.path}`}
                        primaryText={item.name}
                        leftIcon={item.icon}
                        onClick={this.props.onMenuClick}
                        dense={this.props.dense}
                    />
                )
            } else if (item.subitems){
                return (
                    <SubMenu
                        key={item.name}
                        handleToggle={() => this.handleToggle(item.subitemId)}
                        isOpen={this.state[item.subitemId]}
                        sidebarIsOpen={this.props.open}
                        name={item.name}
                        icon={item.icon}
                    >
                    {item.subitems.map(item => this.renderItem(item, role))}
                    </SubMenu>
                )
            } else {
                return null
            }

        } else {
            return null
        }
    }

    render() {
        const items = [
            {
                name: 'Inicio',
                path: '/',
                icon: <DashboardIcon />,
                roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest']
            },
            {
                name: 'Activos',
                icon: <InstalationsIcon />,
                roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest'],
                subitemId : 'menuActivos',
                subitems : [
                    {
                        name: 'Instalaciones',
                        path: '/instalaciones',
                        icon: <InstalationsIcon />,
                        roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest']
                    },
                    {
                        name: 'Estructuras y OO.CC.',
                        path: '/estructuas-y-oocc',
                        icon: <BienesIcon />,
                        roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest']
                    },
                    {
                        name: 'EIA',
                        path: '/eias',
                        icon: <EDAIcon />,
                        roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest']
                    },
                ]
            },
            {
                name: 'Certificar',
                path: '/certificacion',
                icon: <CertificationIcon />,
                roles: ['admin', 'coordinador', 'externo']
            },
            {
                name: 'Validar Reg.Instalación',
                path: '/validar-instalaciones',
                icon: <ValidationIcon />,
                roles: ['admin', 'coordinador']
            },
            {
                name: 'Datos Técnicos',
                path: '/datos-tecnicos',
                icon: <TechDataIcon />,
                roles: ['admin', 'coordinador', 'externo']
            },
            {
                name: 'Reporte',
                icon: <TechDataIcon />,
                roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest'],
                subitemId : 'menuReportes',
                subitems : [
                    {
                        name: 'Por Empresa',
                        path: '/reportes',
                        icon: <TechDataIcon />,
                        roles: ['admin', 'coordinador', 'externo', 'guest', 'coordinado']
                    }, 
                    {
                        name: 'Por Proyectos',
                        path: '/reportes-proyectos',
                        icon: <TechDataIcon />,
                        roles: ['admin', 'coordinador', 'externo', 'guest', 'coordinado']
                    }, 
                ]
            },
            {
                name: 'Esquemas',
                path: '/esquemas-datos-tecnicos',
                icon: <SchemasIcon />,
                roles: ['admin', 'coordinador']
            },
            {
                name: 'Fichas Técnicas',
                path: '/esquemas-fichas-tecnicas',
                icon: <SchemasIcon />,
                roles: ['admin', 'coordinador']
            },
            {
                name: 'Mantenedor Items',
                path: '/mantenedor',
                icon: <OptionsIcon />,
                roles: ['admin', 'coordinador', 'externo']
            },
            {
                name: 'Descarga Base Datos',
                path: '/descarga-base-datos',
                icon: <DBIcon />,
                roles: ['admin', 'coordinador', 'externo', 'coordinado', 'guest']
            },
            {
                name: 'Usuarios',
                icon: <UserIcon />,
                roles: ['admin'],
                subitemId : 'menuUsuarios',
                subitems : [
                    {
                        name: 'Usuarios Coordinador',
                        path: '/usuarios-coordinador',
                        icon: <UserIcon />,
                        roles: ['admin']
                    },
                    {
                        name: 'Usuarios Coordinados',
                        path: '/usuarios-coordinados',
                        icon: <UserIcon />,
                        roles: ['admin']
                    },
                ]
            },
            {
                name: 'Notificaciones',
                path: '/notificaciones',
                icon: <NotificationIcon />,
                roles: ['admin']
            },
        ];
        const { permissions } = this.state

        return (
            <div className={this.props.classes.menu}>
                {items.map(item => this.renderItem(item, permissions.role))}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Menu)))
